// BackgroundSection.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const BackgroundSection = ({ images = [
  '/assets/img/auth/ofi-2-plan-recambios-botellon-20l-dispensador-pedidos-online-entrega-domicilio-agua-purificada-calidad.png',
  '/assets/img/auth/adultos-plan-recambios-botellon-20l-dispensador-pedidos-online-entrega-domicilio-agua-purificada-calidad.png',
  '/assets/img/auth/bajar-plan-recambios-botellon-20l-dispensador-pedidos-online-entrega-domicilio-agua-purificada-calidad.png',
  '/assets/img/auth/futbol-plan-recambios-botellon-20l-dispensador-pedidos-online-entrega-domicilio-agua-purificada-calidad.png',
  '/assets/img/auth/oficina-plan-recambios-botellon-20l-dispensador-pedidos-online-entrega-domicilio-agua-purificada-calidad.png',
  '/assets/img/auth/trabajo-plan-recambios-botellon-20l-dispensador-pedidos-online-entrega-domicilio-agua-purificada-calidad.png',
  // Añade más imágenes aquí
] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div
      className="w-full relative flex flex-col items-start justify-between px-6 md:p-8 py-6 text-white overflow-hidden"
    >
      {/* Slideshow de imágenes */}
      {images.map((image, index) => (
        <div
          key={index}
          className="absolute inset-0 w-full h-full transition-opacity duration-1000 ease-in-out"
          style={{
            backgroundImage: `url(${image})`,
            backgroundPosition: 'center center',
            backgroundSize: 'cover',
            opacity: index === currentIndex ? 1 : 0,
            zIndex: 0
          }}
        />
      ))}
      
      {/* Overlay con gradiente */}
      <div 
        className="absolute inset-0 w-full h-full"
        style={{
          background: `linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.12))`,
          zIndex: 1
        }}
      />


      {/* Contenido de texto */}
      <div className="min-w-full relative z-10 mt-auto">
        <h1 className="text-4xl lg:text-5xl font-medium mb-4">
          Hidratación que no se detiene
        </h1>
        <p className="text-lg lg:text-xl">
          Innovamos constantemente en como mantenerte hidratado.
        </p>
        <div className="mt-auto py-8">
          <div className="flex justify-between text-sm text-white">
            <a href="/terminos" className="hover:text-gray-200">
              Términos
            </a>
            <a href="/privacidad" className="hover:text-gray-200">
              Privacidad
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};